import { render, staticRenderFns } from "./new-business-driver-profile.vue?vue&type=template&id=3bc06209&"
import script from "./new-business-driver-profile.vue?vue&type=script&lang=js&"
export * from "./new-business-driver-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports